import { PaginationTable } from "js/components/types";

import {
  CreateOrderPayload,
  OrderFilters,
  TransactionFilters,
} from "js/pages/Quotas/types";

import { AxiosInstance } from "../utils/AxiosInstance";

export const getQuotaPackages = async () => {
  const { data } = await AxiosInstance.get(`/v1/quotas/packages`);
  return data;
};

export const createQuotaOrder = async (payload: CreateOrderPayload) => {
  const { data } = await AxiosInstance.post(
    `/v1/quotas/orders/create`,
    payload,
  );
  return data;
};

export const getQuotaOrders = async (
  pagination: PaginationTable,
  filters?: OrderFilters,
) => {
  const { data } = await AxiosInstance.get(`/v1/quotas/orders`, {
    params: {
      limit: pagination.pageSize,
      offset: (pagination.current - 1) * pagination.pageSize,
      ...(filters?.quote_type && { quote_type: filters.quote_type }),
      ...(filters?.date_from && { date_from: filters.date_from }),
      ...(filters?.date_to && { date_to: filters.date_to }),
      ...(filters?.search && { search: filters.search }),
      ...(filters?.ordering && { ordering: filters.ordering }),
    },
  });
  return data;
};

export const getQuotaOrder = async (orderId: string) => {
  const { data } = await AxiosInstance.get(`/v1/quotas/orders/${orderId}`);
  return data;
};

export const cancelQuotaOrder = async (orderId: string) => {
  const { data } = await AxiosInstance.post(
    `/v1/quotas/orders/${orderId}/cancel`,
  );
  return data;
};

export const getQuotaTransactions = async (
  pagination: PaginationTable,
  filters?: TransactionFilters,
) => {
  const { data } = await AxiosInstance.get(`/v1/quotas/transactions`, {
    params: {
      limit: pagination.pageSize,
      offset: (pagination.current - 1) * pagination.pageSize,
      ...(filters?.quote_type && { quote_type: filters.quote_type }),
      ...(filters?.transaction_type && {
        transaction_type: filters.transaction_type,
      }),
      ...(filters?.date_from && { date_from: filters.date_from }),
      ...(filters?.date_to && { date_to: filters.date_to }),
      ...(filters?.search && { search: filters.search }),
      ...(filters?.ordering && { ordering: filters.ordering }),
      ...(filters?.performed_by && { performed_by: filters.performed_by }),
    },
  });
  return data;
};

export const exportQuotasCSV = async (
  type: "transactions" | "orders" | "all",
  filters?: {
    quote_type?: string;
    transaction_type?: string;
    date_from?: string;
    date_to?: string;
    performed_by?: string;
  },
) => {
  const { data } = await AxiosInstance.get(`/v1/quotas/export`, {
    params: {
      type,
      ...(filters?.quote_type && { quote_type: filters.quote_type }),
      ...(filters?.transaction_type && { transaction_type: filters.transaction_type }),
      ...(filters?.date_from && { date_from: filters.date_from }),
      ...(filters?.date_to && { date_to: filters.date_to }),
      ...(filters?.performed_by && { performed_by: filters.performed_by }),
    },
    responseType: "blob",
  });
  return data;
};
